import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { type MenuItemDefinition } from '@menu-lib/components/AppLayout/types';

export class MenuItemRegistry {
  private static items = new Map<MenuItems, MenuItemDefinition>();

  static register(menuItem: MenuItems, definition: MenuItemDefinition): void {
    if (this.items.has(menuItem)) {
      throw new Error(`MenuItems.${MenuItems[menuItem]} is al geregistreerd`);
    }
    this.items.set(menuItem, definition);
  }

  static get(menuItem: MenuItems): MenuItemDefinition | undefined {
    return this.items.get(menuItem);
  }

  static getAll(): MenuItemDefinition[] {
    return Array.from(this.items.entries())
      .sort(([a], [b]) => a - b)
      .map(([, definition]) => definition);
  }

  static clear(): void {
    this.items.clear();
  }
}
